import { useState } from 'react';
import { AdaptiveOverlay } from './adaptive-overlay';
import { KitButton } from './button';

export interface ActionMenuProps {
  label: string;
  ariaLabel?: string;
  title: string;
  closeLabel: string;
  disabled?: boolean;
  actions: Array<{ id: string; label: string; disabled?: boolean; onSelect(): void }>;
}

/** Owner callbacks submit/reconcile their admitted operation. Selecting an
 * action here changes no row or authority and creates no optimistic receipt.
 */
export function ActionMenu({
  label,
  ariaLabel,
  title,
  closeLabel,
  disabled,
  actions,
}: ActionMenuProps) {
  const [open, setOpen] = useState(false);
  return (
    <AdaptiveOverlay
      open={open}
      onOpenChange={setOpen}
      disabled={disabled}
      title={title}
      closeLabel={closeLabel}
      trigger={
        <KitButton variant="quiet" aria-label={ariaLabel ?? label} disabled={disabled}>
          {label}
        </KitButton>
      }
    >
      {actions.map((action) => (
        <KitButton
          key={action.id}
          variant="quiet"
          disabled={action.disabled || disabled}
          onClick={() => {
            setOpen(false);
            action.onSelect();
          }}
        >
          {action.label}
        </KitButton>
      ))}
    </AdaptiveOverlay>
  );
}
